// This file is auto-generated by the generate:translations task. Do not edit directly.
/* eslint-disable no-unused-vars */
enum Namespace {
  AdminPortal = 'adminPortal',
  ErrorPage = 'errorPage',
  Forms = 'forms',
  General = 'general',
  OrderHistory = 'orderHistory',
}

export { Namespace };
